
    // **BEGIN** Hextom TMS Integration - DO NOT MODIFY
      var hextom_tms = {
        selectorInsertType:  "float",
        regionType:  "region_name_currency_symbol",
        floatingPosition: "bottom_left",
        floatingPaddingHorizontal:  15,
        floatingPaddingVertical:  15,
        availableLocalesById: {},
        availableLocales: [],
        primaryLocaleById: {},
        merchantSelectedLocale: "browser_base",
        hasFlag: "no",
        selectorFlagMap: {'es': 'es', 'en': 'en'},
        displayType: "language_name",
        fontColor: "#000000",
        backgroundColor: "#FFFFFF",
        backgroundOpacity: "0.65",
        buttonFontColor: "#FFFFFF",
        buttonBackgroundColor: "#000000",
        selectorType: "market_language",
        selectorStyle: "dropdown",
        hasFlagRegion: "yes",    
        defaultRegion: "ip_base",    
        primaryRegionById: {},    
        availableRegionsByCode: {},    
        availableRegions: [],
        primaryDomain: "",
        popupEnable: false,
        popupTextColor: "#000000",
        popupBgColor: "#FFFFFF",
        popupBtnTextColor: "#FFFFFF",
        popupBtnBgColor: "#000000",
        regions: [{"name": "Spain", "code": "ES", "currency": {"code": "EUR", "symbol": "\u20ac"}, "languages": {"Espa\u00f1ol": {"name": "Espa\u00f1ol (Spanish)", "native_name": "Espa\u00f1ol", "code": "es", "default": true}, "English": {"name": "English", "native_name": "English", "code": "en", "default": false}}, "primary": true}],
      };
    // **END** Hextom TMS Integration - DO NOT MODIFY
    